<!-- ============================================================== -->
<!-- Only router without any element -->
<!-- ============================================================== -->
<mat-sidenav-container
  [ngClass]="{
    'cardBorder': options.cardBorder,
    green_theme: options.activeTheme == 'green_theme',
  }"
  [dir]="options.dir!"
>
  <router-outlet></router-outlet>
</mat-sidenav-container>
